import * as React from 'react';

const CartContext = React.createContext(null);
CartContext.displayName = 'CartContext';
const useCart = ()=>{
    const context = React.useContext(CartContext);
    if (!context) {
        throw new Error('No Cart available. You might still need to wrap the application with the CartProvider component.');
    }
    return context;
};

export { CartContext, useCart };
//# sourceMappingURL=context.js.map
